import styled from 'styled-components';
export const CheckboxWrapper = styled.div `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
export const CheckboxInput = styled.input `
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
`;
export const Checkmark = styled.div `
  position: relative;
  top: 0;
  left: 0;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: ${(props) => props.rounded};
  border: 1px solid var(--contorno-click-botn, #d6e3f3);
  background-color: ${(props) => (props.isChecked ? 'none' : 'var(--Blanco, #fff)')};
  box-shadow: ${(props) => props.isChecked
    ? 'none'
    : '4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset'};
`;
export const CheckmarkSVG = styled.svg `
  position: absolute;
  transform: translate(-50%, -50%);
  width: ${(props) => props.size * 2}px;
  height: ${(props) => props.size * 2}px;
  z-index: 20;
`;
export const DisabledCheckmark = styled.svg `
  position: absolute;
  top: 13px;
  left: 13px;
  transform: translate(-50%, -50%);
  width: 26px;
  height: 26px;
`;
export const CheckboxLabel = styled.label `
  user-select: none;
  color: ${(props) => props.highlightedText ? 'var(--Azul-primario-500, #0057B8)' : 'var(--Gris-700, #5b5d71)'};
  font-family: Poppins;
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '14px')};
  font-style: normal;
  font-weight: ${(props) => (props.highlightedText ? '500' : '500')};
  line-height: 100%;
  margin-left: 10px;
  min-width: 200px;
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=styled.js.map